import { IStatus } from 'features/lobby/interface/lobby';

const PROFILE_DETAILS = {
	accountId: '',
	userName: '',
	firstName: '',
	lastName: '',
	email: '',
	avatarUrl: '',
	gender: '',
	dob: '',
	mobileNo: null,
	termAgreed: true,
	streetHouseNo: null,
	country: '',
	city: null,
	postCode: null,
	nationality: null,
	nameAtBirth: null,
	countryOfBirth: null,
	cityOfBirth: null,
	notifyPromotion: true,
	notifyOnContest: false,
	isKycVerified: false,
	adsRefId: '',
	adsSubId: '',
	isPopUpShown: false,
	kycStatus: '',
	wonAmount: 0,
	walletAmount: 0,
	totalPlays: 0,
	totalWins: 0
};

const LOBBY_REDIRECTION_TABS: IStatus = {
	Upcoming: 'Arena',
	Joined: 'Joined',
	Live: 'Live',
	Finished: 'Finished'
};

export { PROFILE_DETAILS, LOBBY_REDIRECTION_TABS };
